import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { LoaderComponent } from '../components/loader/loader.component';
import { GetReqUrlPipe } from '../pipes/get-req-url.pipe';
import { PropertyNamePipe } from '../pipes/prorerty-name.pipe';
import { ElementsSharedModule } from './elements-shared.module';
import { NumberParserPipe } from '../pipes/number-parser.pipe';
import { SetFileSizePipe } from '../pipes/set-file-size.pipe';
import { NumberFormatDirective } from '../directives/number-formatter.directive';
import { SingleStarComponent } from 'src/app/private/pages/explore/pages/details-fund-stock/components/single-star/single-star.component';
import { PriceCardComponent } from './../components/templates/price-card/price-card.component';
import { SmileComponent } from 'src/app/private/pages/explore/pages/details-fund-stock/components/smile/smile.component';
import { ArrowComponent } from 'src/app/private/pages/explore/pages/details-fund-stock/components/arrow/arrow.component';
import { CheckSignComponent } from 'src/app/private/pages/explore/pages/details-fund-stock/components/check-sign/check-sign.component';
import { SearchComponent } from 'src/app/private/components/header/search.component';


@NgModule({
    imports: [
        CommonModule,
        ElementsSharedModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: PublicHttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
      
    ],
    declarations: [
        LoaderComponent,
        GetReqUrlPipe,
        PropertyNamePipe,
        NumberParserPipe,
        SetFileSizePipe,
        NumberFormatDirective,
        SingleStarComponent,
        PriceCardComponent,
        SmileComponent,
        ArrowComponent,
        CheckSignComponent,
        SearchComponent
    ],
    exports: [
        CommonModule,
        ElementsSharedModule,
        LoaderComponent,
        GetReqUrlPipe,
        PropertyNamePipe,
        NumberParserPipe,
        SetFileSizePipe,
        SingleStarComponent,
        PriceCardComponent,
        SmileComponent,
        ArrowComponent,
        CheckSignComponent,
        SearchComponent
    ],
})
export class SharedModule {}

export function PublicHttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/public/', '.json');
}
